// Roster service constants
export const ROSTER_SERVICE_CLEVER = 'clever'
export const ROSTER_SERVICE_ONEROSTER = 'oneroster'
export const ROSTER_SERVICE_S3CSV = 's3csv'

// Roster service display names
export const ROSTER_SERVICE_NAMES = {
  [ROSTER_SERVICE_CLEVER]: 'Clever',
  [ROSTER_SERVICE_ONEROSTER]: 'Oneroster',
  [ROSTER_SERVICE_S3CSV]: 'SFTP'
}
